<template>
  <router-view id="router-view" />
</template>

<script>
export default {}
</script>
<style lang="scss">
.card-title {
  padding: 0 0 0 20px;
  font-size: 18px;
}
</style>
